<template>
  <div v-on="computedEvents">
    <div class="d-flex justify-space-between align-center px-4 py-3 item" @click="toggleItem">
      <div :class="{ 'main-level-text': level === 1 }">
        {{ hasChildren ? `${$i18n.t(`default.${levelPrefix}`)} ${item.name}` : item.name }}
      </div>
      <div
        :style="`white-space: nowrap; min-width: ${hasChildren ? '17' : '50'}px; height: 17px; border-radius: 8.5px`"
        class="d-flex justify-center align-center white--text secondary ml-1 px-1"
      >
        {{ badgeValue }}
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SidebarListItem',
  props: {
    level: {
      type: Number,
      default: 0,
    },
    item: {
      type: Object,
      default: () => {},
    },
    areaUnit: {
      type: String,
      default: 'ha',
    },
    offersLayerId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    badgeValue() {
      if (this.hasChildren) {
        return this.item.count;
      } else if (this.hasArea) {
        return `${this.item.area?.toFixed(2)} ${this.areaUnit}`;
      } else {
        return 0;
      }
    },
    hasArea() {
      return Object.hasOwn(this.item, 'area');
    },
    hasChildren() {
      return Object.hasOwn(this.item, 'children');
    },
    levelPrefix() {
      return { 1: 'voivodeship', 2: 'district', 3: 'commune' }[this.level];
    },
    computedEvents() {
      return this.hasChildren
        ? {}
        : {
            mouseenter: this.onMouseEnter,
            mouseleave: this.onMouseLeave,
          };
    },
  },
  methods: {
    onMouseEnter() {
      this.$store.set('map/ADD_SELECTED_FEATURES!', {
        type: 'highlitedFeatures',
        features: {
          [this.offersLayerId]: [this.item.id],
        },
      });
    },
    onMouseLeave() {
      this.$store.set('map/DELETE_SELECTED_FEATURES!', {
        type: 'highlitedFeatures',
        features: {
          [this.offersLayerId]: [this.item.id],
        },
      });
    },
    toggleItem() {
      if (this.item.children) {
        this.$emit('toggleItem');
      } else {
        this.$router.push({
          name: 'offer',
          params: { lid: this.offersLayerId, fid: this.item.id },
          query: this.$route.query,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  @include border();
  border-top: none !important;
}
.main-level-text {
  font-weight: 500;
  font-size: 14px;
}
</style>
